import React from 'react';
import * as metaPixel from 'meta-pixel';
import { Clock, AlertTriangle } from 'lucide-react';
const handleFinalCTAClick = () => {
  try {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      metaPixel.track('InitiateCheckout', {
        content_name: 'Cría con calma - Final CTA',
        content_category: 'Parenting Guide',
        value: 7.99,
        currency: 'USD'
      });
    }
  } catch (error) {
    console.error('Error tracking final CTA click:', error);
  }
};
export function CTA() {
  return <section className="py-12 bg-gradient-to-b from-white to-amber-50" data-id="element-52">
      <div className="container mx-auto px-4 md:px-6" data-id="element-53">
        <div className="max-w-3xl mx-auto text-center" data-id="element-54">
          <h2 className="text-2xl md:text-3xl font-bold text-amber-900 mb-4 font-serif" data-id="element-55">
            Imagina una semana sin gritos. Solo conexión, cooperación y calma.
          </h2>
          <p className="text-lg text-amber-800 mb-4" data-id="element-56">
            Descubre "Cría con calma" ahora y transforma las rutinas de tu
            familia
          </p>
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6 flex items-center justify-center gap-2" data-id="element-57">
            <Clock className="text-red-600 flex-shrink-0" size={20} data-id="element-58" />
            <p className="text-red-600 font-medium text-sm" data-id="element-59">
              <span className="font-bold" data-id="element-60">¡ÚLTIMA OPORTUNIDAD!</span> Esta
              oferta especial termina hoy a medianoche
            </p>
          </div>
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6" data-id="element-61">
            <div className="flex items-center justify-center gap-2 mb-2" data-id="element-62">
              <AlertTriangle className="text-amber-700" size={20} data-id="element-63" />
              <p className="font-bold text-amber-900" data-id="element-64">¡83% DE DESCUENTO!</p>
            </div>
            <p className="text-amber-800 text-sm" data-id="element-65">
              De <span className="line-through" data-id="element-66">$47.99</span> a solo{' '}
              <span className="font-bold text-red-600" data-id="element-67">$7.99</span> - ¡Por
              tiempo muy limitado!
            </p>
          </div>
          <div className="flex justify-center" data-id="element-68">
            <a href="https://pay.hotmart.com/E103092077E" className="w-full sm:w-auto" onClick={handleFinalCTAClick} data-id="element-69">
              <button className="bg-amber-700 hover:bg-amber-800 text-white font-medium py-3 px-6 rounded-md w-full" data-id="element-70">
                Aprovechar oferta especial
              </button>
            </a>
          </div>
        </div>
      </div>
    </section>;
}